exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pair-device-dialog .pair-device-input {\n  max-width: 100%; }\n\n.pair-device-dialog .pair-device-step-label {\n  max-width: 220px; }\n\n.pair-device-dialog .pair-device-pairing-status {\n  text-align: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/pair_device_dialog/pair_device_dialog.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/pair_device_dialog/pair_device_dialog.scss
// module chunks = index